const links = [
  {
    label: "EMAIL",
    value: "parastousaba@gmail.com",
    href: "mailto:parastousaba@gmail.com",
    testid: "contact-email",
  },
  {
    label: "LINKEDIN",
    value: "/parastou-saba ↗",
    href: "https://www.linkedin.com/in/parastou-saba-6665b9150",
    external: true,
    testid: "contact-linkedin",
  },
  {
    label: "INSTAGRAM",
    value: "@the.directdesigner ↗",
    href: "https://www.instagram.com/the.directdesigner/",
    external: true,
    testid: "contact-instagram",
  },
];

export default function ContactInfo() {
  return (
    <div className="col-span-12 lg:col-span-5">
      <p className="label-mono text-[#FFFFFF]/60 mb-4">/ 05 — Get in touch</p>
      <h2 className="font-display text-5xl md:text-7xl tracking-tighter mb-8">
        Let&apos;s make it <span className="text-[#A78BFA]">clear</span>.
      </h2>
      <p className="text-[#FFFFFF]/80 leading-relaxed max-w-md mb-10">
        Have a tangled product, a flow that isn&apos;t landing, or a full build
        ahead? Tell me what you&apos;re working on — I reply within 24 hours.
      </p>

      <div className="space-y-4 label-mono">
        {links.map((l) => (
          <a
            key={l.label}
            href={l.href}
            {...(l.external ? { target: "_blank", rel: "noreferrer" } : {})}
            className="flex items-center justify-between border-b border-[#FFFFFF]/20 pb-3 hover:text-[#A78BFA] transition-colors"
            data-testid={l.testid}
          >
            <span className="text-[#FFFFFF]/60">{l.label}</span>
            <span>{l.value}</span>
          </a>
        ))}
        <div className="flex items-center justify-between border-b border-[#FFFFFF]/20 pb-3">
          <span className="text-[#FFFFFF]/60">STATUS</span>
          <span className="flex items-center gap-2">
            <span className="w-2 h-2 bg-[#A78BFA] blink" />
            Available for new projects
          </span>
        </div>
      </div>
    </div>
  );
}
